import Swiper from 'swiper/dist/js/swiper.js';
import owd from 'owd/owd';

export default class Slider extends owd.Component {
	init() {
		this.count = this.$element.find('.slider-slide').length;
		this.curr = 1;

		this.prepareDom();
		this.createSlider();
		this.bind();

	}

	prepareDom() {
		this.$element.append('<div class="swiper-container"><div class="swiper-wrapper"></div></div>');
		this.$element.find('.swiper-wrapper').append(this.$element.find('.slider-slide'));
		this.$element.find('.slider-slide').addClass('swiper-slide').each((index, item) => {
			$(item).attr('data-slide-number', index);
		});

		this.$swiperContainer = this.$element.find('.swiper-container');
	}

	getOptions() {
		let keyboard = true;
		let effect = 'slide';
		let autoplay = false;
		let speed = 500;
		let lazyload = this.$swiperContainer.find('.swiper-lazy').length ? true : false;
		let lazy = lazyload ? {
			loadPrevNext: lazyload,
			loadPrevNextAmount: 2,
		} : false;

		let navigation = {
			prevEl: this.$element.find('.button--prev')[0],
			nextEl: this.$element.find('.button--next')[0]
		}

		let pagination = {
			el: this.$element.find('.slider-pagination'),
			clickable: true,
			renderBullet: function (index, className) {
				return '<button type="button" class="' + className + '">' + (index + 1) + '</button>';
			},
			bulletClass: 'slider-pagination-item',
			bulletActiveClass: 'is-active',
			modifierClass: 'slider-pagination-',
			clickableClass: 'is-clickable'
		}

		let options = {
			keyboard: keyboard,
			effect: effect,
			loop: true,
			speed: speed,
			autoplay: autoplay,
			preloadImages: !lazyload,
			lazy,
			navigation : navigation,
			pagination: pagination
		};

		return options;
	}

	createSlider() {
		let options = this.getOptions();

		this.swiper = new Swiper(this.$swiperContainer[0], options);

		this.$element.data('swiperInstance', this.swiper);
		this.$element.trigger('sliderInitialized', this.swiper);
	}

	bind() {
		this.on('slideChangeStart', this.swiper, () => {
			this.curr = parseInt(this.$element.find('.swiper-slide-active').data('slide-number')) + 1;
			$('.curr-slide').html(this.curr);
		});

		this.on('domready load ajaxload pageIn pageInEnd imageload', this.dom.$window, (e) => {
			if (this.swiper) {
				this.swiper.update();
			}
		});

		this.on('imageload', 'img', (e) => {
			if (this.swiper) {
				this.swiper.update();
			}
		});
	}

	destroy() {
		super.destroy();

		if (this.slider) {
			this.swiper.destroy();
		}
	}
}

owd.registerComponent('slider', {
	component: Slider
});
